import { Component } from '@angular/core';

@Component({
  selector: 't-people-management-icon',
  standalone: true,
  imports: [],
  templateUrl: './people-management-icon.component.html',
  styleUrl: './people-management-icon.component.css',
  host: { hostID: crypto.randomUUID().toString() },
})
export class PeopleManagementIconComponent {}
